require('dotenv').config();
const Parse = require('parse');
Parse.initialize(process.env.APP_ID , process.env.JAVASCRIPT_KEY);
Parse.serverURL = 'https://parseapi.back4app.com';
export default Parse;